import { render } from "./order_details.vue?vue&type=template&id=acb738ce&scoped=true&ts=true"
import script from "./order_details.vue?vue&type=script&lang=ts"
export * from "./order_details.vue?vue&type=script&lang=ts"

import "./order_details.vue?vue&type=style&index=0&id=acb738ce&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb738ce"]])

export default __exports__